import React, { useMemo } from "react";
import { getFileTypeIconSrc } from "../utils/fileTypeIcons";

const FileIcon = ({ fileName, mimeType, size = 20, style, alt = "", ...props }) => {
  const src = useMemo(
    () => getFileTypeIconSrc(fileName, mimeType, size),
    [fileName, mimeType, size]
  );

  if (!src) {
    return null;
  }

  return (
    <img
      src={src}
      alt={alt}
      width={size}
      height={size}
      loading="lazy"
      decoding="async"
      style={{ flexShrink: 0, display: "block", objectFit: "contain", ...style }}
      {...props}
    />
  );
};

export default FileIcon;
